package com.kanati.shared.loyalty

import kotlinx.serialization.Serializable

@Serializable
data class LoyaltyAccountDto(
    val id: String,
    val districtId: String,
    val schoolId: String = "",
    val customerName: String,
    val email: String?,
    val phone: String? = null,
    val memberCode: String? = null,
    val pointsBalance: Int,
    val createdAt: String,
    val updatedAt: String,
)

@Serializable
data class CreateLoyaltyAccountRequest(
    val districtId: String,
    val schoolId: String = "",
    val customerName: String,
    val email: String? = null,
    val phone: String? = null,
)

@Serializable
data class LoyaltyRewardDto(
    val id: String,
    val districtId: String,
    val schoolId: String = "",
    val name: String,
    val description: String?,
    val pointsCost: Int,
    val fixedDiscountAmount: Long = 0,
    val active: Boolean,
    val createdAt: String,
    val updatedAt: String,
)

@Serializable
data class CreateLoyaltyRewardRequest(
    val districtId: String,
    val schoolId: String = "",
    val name: String,
    val description: String? = null,
    val pointsCost: Int,
    val fixedDiscountAmount: Long,
    val active: Boolean = true,
)

@Serializable
data class UpdateLoyaltyRewardRequest(
    val districtId: String,
    val schoolId: String = "",
    val name: String? = null,
    val description: String? = null,
    val pointsCost: Int? = null,
    val fixedDiscountAmount: Long? = null,
    val active: Boolean? = null,
)

@Serializable
data class LoyaltyAccountSummaryDto(
    val id: String,
    val customerName: String,
    val pointsBalance: Int,
)

@Serializable
data class LoyaltyRewardSummaryDto(
    val id: String,
    val name: String,
    val pointsCost: Int,
    val fixedDiscountAmount: Long,
)

@Serializable
data class LoyaltyAccountLookupRequest(
    val districtId: String,
    val schoolId: String = "",
    val phone: String? = null,
    val memberCode: String? = null,
    val email: String? = null,
)

@Serializable
data class LoyaltyAccountLookupResponse(
    val account: LoyaltyAccountSummaryDto,
    val availableRewards: List<LoyaltyRewardSummaryDto>,
    val recommendedReward: LoyaltyRewardSummaryDto? = null,
)

@Serializable
data class LoyaltyPointsLedgerEntryDto(
    val id: String,
    val accountId: String,
    val districtId: String,
    val schoolId: String = "",
    val pointsDelta: Int,
    val reason: String,
    val rewardId: String? = null,
    val createdAt: String,
)

@Serializable
data class AdjustLoyaltyPointsRequest(
    val districtId: String,
    val schoolId: String = "",
    val pointsDelta: Int,
    val reason: String,
)

@Serializable
data class LoyaltyRedemptionRequest(
    val districtId: String,
    val schoolId: String = "",
    val rewardId: String,
)

@Serializable
data class LoyaltyRedemptionResponse(
    val account: LoyaltyAccountDto,
    val reward: LoyaltyRewardDto,
    val ledgerEntry: LoyaltyPointsLedgerEntryDto,
)
